import { Video, Phone } from "lucide-react";

const DAYS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

function weekKey(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  const day = (d.getDay() + 6) % 7; // lundi=0
  const monday = new Date(d);
  monday.setDate(d.getDate() - day);
  return monday.toISOString().slice(0, 10);
}

function weekLabel(mondayStr) {
  const m = new Date(mondayStr + "T00:00:00");
  const s = new Date(m); s.setDate(m.getDate() + 6);
  return `Semaine du ${m.getDate()} ${MONTHS[m.getMonth()]} au ${s.getDate()} ${MONTHS[s.getMonth()]}`;
}

// Mini-calendrier : regroupe les créneaux par semaine puis par jour (lisible même avec beaucoup de dispo).
export default function SlotPicker({ slots, selected, onSelect, testidPrefix = "slot" }) {
  if (!slots || slots.length === 0) return null;
  const byDay = {};
  slots.forEach((s) => { (byDay[s.date] = byDay[s.date] || []).push(s); });
  const dates = Object.keys(byDay).sort();
  const weeks = {};
  dates.forEach((d) => { const k = weekKey(d); (weeks[k] = weeks[k] || []).push(d); });
  const weekKeys = Object.keys(weeks).sort();

  return (
    <div className="space-y-6" data-testid="slot-picker">
      {weekKeys.map((wk) => (
        <div key={wk}>
          <div className="text-[11px] tracking-[0.14em] uppercase font-semibold text-obsidian/40 mb-3">{weekLabel(wk)}</div>
          <div className="space-y-3">
            {weeks[wk].map((d) => {
              const dt = new Date(d + "T00:00:00");
              return (
                <div key={d} className="grid grid-cols-[92px_1fr] gap-3 items-start">
                  <div className="pt-2">
                    <div className="text-sm font-medium capitalize">{DAYS[dt.getDay()]}</div>
                    <div className="text-xs text-obsidian/45">{dt.getDate()} {MONTHS[dt.getMonth()]}</div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {byDay[d].sort((a, b) => a.hour - b.hour).map((s) => {
                      const active = selected?.id === s.id;
                      return (
                        <button key={s.id} data-testid={`${testidPrefix}-${s.id}`} onClick={() => onSelect(s)}
                          className={`rounded-xl border px-3.5 py-2.5 text-sm transition-[background-color,border-color] ${active ? "border-obsidian bg-obsidian text-white" : "border-border bg-white hover:border-obsidian/40"}`}>
                          <span className="font-medium tabnum">{s.hour}h00</span>
                          <span className={`ml-2 inline-flex items-center gap-1 text-[10px] ${active ? "text-white/70" : "text-obsidian/45"}`}>
                            {s.mode === "phone" ? <><Phone size={9} /> Tél</> : <><Video size={9} /> Visio</>}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
